export default {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
};
